import React, { FC, JSX } from 'react';

export type AccordionContainerProps = {
  children: React.ReactNode,
  collapse?: boolean
}

export const AccordionContainer: FC<AccordionContainerProps & React.HTMLProps<HTMLUListElement>> = (props) => {
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const collapseProps = (child: JSX.Element, index: number) => {
    return {
      onClick: (event: any) => {
        setActiveIndex(index);
        if (child.props.onClick) child.props.onClick(event);
      },
      active: activeIndex === index
    } as AccordionProps
  }

  const mappedChildren = React.Children.map(props.children, (child, index) => {
    if (React.isValidElement(child) && props.collapse) {
      return React.cloneElement(child, collapseProps(child, index));
    }

    return child;
  });

  return (
    <ul
      className="p-0 list-none border-b border-gray-300"
      {...props}
    >
      {mappedChildren}
    </ul>
  );
}

export type AccordionContentProps = {
  active?: boolean;
  children: React.ReactNode
}

export const AccordionContent: FC<AccordionContentProps> = (props) => {
  return (
    <div className={props.active ? "mb-8 block" : "mb-0 hidden"}>
      {props.children}
    </div>
  );
};

export type AccordionProps = {
  onClick?: (event: any) => void;
  title: string
  children: React.ReactNode,
  active?: boolean;
}

export const Accordion: FC<AccordionProps> = (props) => {
  const isActive = (): boolean => {
    return active && (props.active !== undefined ? props.active : true);
  };

  const [active, setActive] = React.useState(props.active ?? false);

  const handleClick = (event: any) => {
    setActive(!isActive());
    if (props.onClick) props.onClick(event);
  };

  return (
    <li className='border-t border-in-black-25'>
      <button
        onClick={handleClick}
        className={`text-left border-none cursor-pointer px-2 py-[10px] flex flex-row w-full `
          + (isActive() ? 'bg-in-black-25' : 'bg-transparent')
          + ' hover:bg-in-black-25'}>
        <span className="flex-1 text-[1.25rem] leading-[1.25rem] font-normal sm:text-[1.5rem] sm:leading-[1.5rem]">{props.title}</span>
        <div>
          <span
            className="inline-block border-black border-solid border-r-2 border-b-2 p-1"
            style={{
              marginTop: isActive() ? 8 : 4,
              transform: isActive() ? 'rotate(-135deg)' : 'rotate(45deg)',
              WebkitTransform: isActive() ? 'rotate(-135deg)' : 'rotate(45deg)',
            }}
          />
        </div>
      </button>
      <AccordionContent active={isActive()}>
        {isActive() && props.children}
      </AccordionContent>
    </li>
  );
};

